/**
 * DecimalFieldType — liczba zmiennoprzecinkowa. Storage: PG NUMERIC.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function DecimalInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  const stringValue =
    typeof value === 'number' ? String(value) : typeof value === 'string' ? value : '';
  return (
    <input
      type="number"
      step="0.01"
      value={stringValue}
      onChange={(e) => {
        const raw = e.target.value;
        if (raw === '') onChange(null);
        else {
          const n = parseFloat(raw);
          onChange(Number.isFinite(n) ? n : null);
        }
      }}
      disabled={disabled}
      autoFocus={autoFocus}
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const DecimalFieldType: FieldTypeDefinition = {
  type: 'decimal',
  renderInput: (props) => <DecimalInput {...props} />,
  renderCell: (_field, value) => {
    // Postgres NUMERIC zwraca jako string przez pg driver
    if (value === null || value === undefined || value === '') return '';
    const n = typeof value === 'number' ? value : parseFloat(String(value));
    return Number.isFinite(n) ? String(n) : '';
  },
  validate: (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value !== 'number' || !Number.isFinite(value)) return 'invalid_decimal';
    return null;
  },
  defaultValue: null,
};
